import { RouterProvider } from 'react-router-dom';

import router from '../../routers/router';

function AppBase() {
  return (
    <RouterProvider
      router={router}
      future={{
        v7_startTransition: true,
      }}
    />
  );
}

export default AppBase;
